const enTranslations = {
  // Navbar
  'about': 'About Us',
  'solutions': 'Solutions',
  'contact': 'Contact',
  
  // Hero Section - Main page
  'hero_title': 'We are harnessing, storing, and optimizing the future of energy.',
  'hero_subtitle1': 'Our team passionately believes that renewable energy is crucial for the healthy future of our planet. Our advanced solution integrates the latest technologies to maximize the performance and return on investment of your renewable energy system.',
  'hero_subtitle2': 'By optimizing energy consumption, you not only save costs but also significantly contribute to reducing carbon emissions and creating a cleaner, greener future.',
  'hero_cta_arbitrinity': 'Discover the Arbitrinity Solution',
  'hero_cta_contact': 'Contact',

  // Arbitrinity Hero Section
  'arbitrinity_hero_title': 'Our Mission: Empowering renewable energy prosumers and traders to unlock the full potential of their energy and storage systems.',
  'arbitrinity_hero_cta1': 'The Solution',
  'arbitrinity_hero_cta2': 'Contact',

  // Market Situation
  'market_situation_title': 'Market Situation',
  'market_situation_text1': 'Challenges in the energy market are becoming increasingly complex. In addition to macroeconomic and energy security factors, tightening European climate policies are placing greater pressure on industry players. The risk of global lag in innovation, along with inflation-induced economic pressure, further aggravates the situation.',
  'market_situation_text2': 'The electricity market is particularly affected by daily and annual production imbalances, leading to significant price fluctuations. While the share of renewable energy sources continues to grow, the energy grid infrastructure struggles to cope with integration, resulting in economic issues.',
  'market_situation_text3': 'For electricity consumers and traders, the underutilization of renewable energy sources represents a significant loss. For industrial users, up to 40% of produced green energy can go to waste due to a lack of tools and solutions for aligning consumption with production. Energy supply costs and unpredictability continue to rise, while the demand for sustainable and cost-effective operations becomes increasingly urgent.',

  // Solution Section
  'solution_title': 'The Solution',
  'solution_subtitle': 'An integrative platform that brings together all stakeholders.',
  'solution_point1': '1.) Optimizes the energy consumption and production of companies in which renewables are integrated with energy storage systems.',
  'solution_point2': '2.) Capable of system-level reserve services as required by regulators.',
  'solution_point3': '3.) Provides flexibility and multiple service opportunities for aggregators and energy traders.',

  'solution_card1_title': 'Intelligent Energy Management',
  'solution_card1_desc': 'Automated system optimizing energy flow between solar panels, batteries, and the grid.',
  'solution_card2_title': 'Data-driven',
  'solution_card2_desc': 'Processes all available data in real time and optimizes it using a learning algorithm.',
  'solution_card3_title': 'System-wide',
  'solution_card3_desc': 'Designed with a holistic approach to the complexity of the electricity sector.',
  'solution_card4_title': 'Minimal hardware requirements',
  'solution_card4_desc': 'No need for extensive new installations—only one device, which we provide.',
  'solution_card5_title': 'Easy management',
  'solution_card5_desc': 'After signing a contract, the platform requires minimal intervention and offers an intuitive interface for monitoring results.',
  'solution_card6_title': 'Support',
  'solution_card6_desc': 'Our experts are available to help achieve optimal system utilization.',
  'solution_card7_title': 'Real-time performance monitoring',
  'solution_card7_desc': 'Track your energy system\'s performance and energy production anytime, anywhere.',
  'solution_card8_title': 'Secure operation',
  'solution_card8_desc': 'Advanced security protocols protect your system and data from external interference.',

  // Features Section
  'features_title': 'Key Features',
  'features_list1': 'Reduces the payback period of an average consumer\'s energy storage investment by half.',
  'features_list2': 'Maximizes the efficiency of renewable energy systems—no wasted energy (Reverse Watt Systems).',
  'features_list3': 'Provides control over external factors.',
  'features_list4': 'Our scheduling service reduces the risks for energy traders.',
  'features_list5': 'Increases the stability of the electricity market.',
  'features_list6': 'Enhances the competitiveness of businesses.',

  // Actors Section
  'actors_title': 'Stakeholders',
  'actors_card1_title': 'Client (Business)',
  'actors_card1_desc': 'We optimize operations and halve the payback period of energy storage investments.',
  'actors_card2_title': 'Energy Trader',
  'actors_card2_desc': 'Minimizes risk associated with electricity price fluctuations.',
  'actors_card3_title': 'BlueTech Energy Solution',
  'actors_card3_desc': 'Uses data-driven optimization to enhance client operations.',
  'actors_card4_title': 'Aggregator',
  'actors_card4_desc': 'Provides data on expected operations.',

  // Awards Section
  'awards_title': 'Awards',
  'awards_description': 'We reached the pre final of the Amsterdam Science & Innovation Award 2025',
  'awards_details': '(Result announcement: June 17, 2025)',
  'awards_read_more': 'Read more here',

  // About Section
  'about_title': 'About Us',
  'about_text1': 'Blue Tech was founded with the mission of providing innovative solutions in the energy sector.',
  'about_text2': 'We take pride in pioneering advancements in energy efficiency and optimization. Our Arbitrinity system represents the latest technology in our portfolio, revolutionizing the performance and profitability of renewable energy systems.',
  'about_text3': 'Our goal is to assist our clients in optimizing their energy consumption, reducing costs, and making their energy systems future-proof and resilient, while also significantly contributing to carbon emission reduction and the stability of the electricity market.',
  
  // Values Section
  'values_title': 'Core Values',
  'values_card1_title': 'Innovation',
  'values_card1_desc': 'We continuously develop our solutions to stay at the forefront of technology and deliver the best results for our clients.',
  'values_card2_title': 'Sustainability',
  'values_card2_desc': 'Every decision and development is guided by environmental sustainability and responsibility towards future generations.',
  'values_card3_title': 'Partnership',
  'values_card3_desc': 'We work closely with our clients and partners to achieve the best performance together and build a sustainable future.',

  // CTA Section
  'cta_title': 'Ready for More Efficient Energy Management?',
  'cta_subtitle': 'Discover our Arbitrinity solution, which maximizes the performance and profitability of your renewable energy system.',
  'cta_button': 'Explore Arbitrinity',

  // Contact Section
  'contact_title': 'Contact',
  'contact_subtitle': 'Subscribe to be the first to receive updates on our solution.',
  'contact_name': 'Name',
  'contact_company': 'Company Name',
  'contact_person': 'Contact Person Name',
  'contact_email': 'Email Address',
  'contact_phone': 'Phone Number',
  'contact_business_type': 'Business Type',
  'contact_design_services': 'Interested in design services?',
  'contact_message': 'Message',
  'contact_privacy': 'By completing the form, you accept the Privacy Policy.',
  'contact_button': 'Subscribe',
  'contact_message_placeholder': 'Write about the company, solar system, battery (if available), etc.',
  'contact_processing': 'Processing...',
  
  // Basic Contact Form
  'contact_basic_subtitle': 'Do you have any questions? We\'re happy to help! Fill out the form below, and one of our expert colleagues will get in touch with you shortly, or write to',
  'contact_basic_email_link': 'info@btes.hu',
  'contact_basic_email_suffix': 'email address.',
  'contact_basic_name': 'Name',
  'contact_basic_email': 'Email Address',
  'contact_basic_message': 'Message',
  'contact_basic_privacy': 'By completing the form, you accept the Privacy Policy. Your data will only be used for contact purposes.',
  'contact_basic_send': 'Send Message',
  'contact_basic_sending': 'Sending...',

  // Footer
  'footer_description': 'Innovative solutions for the optimal use of renewable energy.',
  'copyright': '© {year} BlueTech. All rights reserved.',
  'privacy_policy_link': 'Privacy Policy',
  'privacy_policy': 'Privacy Policy',

  // Business Types
  'business_type_default': 'Choose a business type',
  'business_type_small': 'Small Business',
  'business_type_medium': 'Medium Business',
  'business_type_large': 'Large Business',
  'business_type_sole': 'Sole Proprietorship',
  
  // EMS Calculator Page
  'ems_nav': 'EMS Calculator',
  'ems_hero_title': 'EMS - The Foundation of Future-Proof Power Plants',
  'ems_hero_subtitle': 'The foundation of modern energy systems is reliable control and real-time data, ensuring stable operation, cost-effectiveness, and maximum production performance. Our solutions help ensure that your solar and energy storage investments truly pay off.',
  
  'ems_calculator_title': 'Calculator',
  'ems_calculator_subtitle': 'Our goal is to provide project-level estimates that enable our partners to:',
  'ems_calculator_point1': 'receive preliminary price estimates for our EMS systems based on a few basic data points,',
  'ems_calculator_point2': 'review which modules can extend the system,',
  'ems_calculator_point3': 'and more easily plan the technical and cost structure of their investment.',
  
  'ems_hardware_title': 'EMS Hardware and Software',
  'ems_hardware_subtitle': 'The EMS hardware and control system we offer ensures:',
  'ems_hardware_point1': 'reliable, stable, and optimized power plant operation,',
  'ems_hardware_point2': 'coordinated control of renewable energy production and energy storage,',
  'ems_hardware_point3': 'continuous compliance with grid regulations and operational requirements,',
  'ems_hardware_point4': 'and transparent, real-time monitoring of the entire energy flow.',
  
  'ems_why_title': 'Why Choose Us?',
  'ems_why_point1': '10+ years of experience in power plant control and energy system design',
  'ems_why_point2': 'Deep integration: PV + BESS + EMS in a unified system',
  'ems_why_point3': 'Modular, customizable solutions',
  'ems_why_point4': 'Maximum operational reliability and optimization',
  'ems_why_point5': 'We cover the entire process from planning to operation',
  
  'ems_pricing_title': 'What Does the Indicative Price Include?',
  'ems_pricing_hardware': 'Hardware',
  'ems_pricing_software': 'Software - 5 years',
  'ems_pricing_config': 'Configuration fee',
  'ems_pricing_installation': 'On-site installation fee (if required)',
  
  'ems_cta_text': 'Our goal is for our clients to achieve the highest efficiency, return on investment, and operational reliability with their energy systems.',
  'ems_cta_contact': 'Contact us, and we will help you design the best technical and economic solution.',
  'ems_cta_button': 'Get Quote',
  
  'ems_form_title': 'Calculator',
  'ems_form_subtitle': 'Fill out the form and view our indicative quote.',
  'ems_form_project_name': 'Project Name',
  'ems_form_pv_power': 'PV Inverter(s) AC Power (kW)',
  'ems_form_battery_power': 'Battery Inverter(s) AC Power (kW)',
  'ems_form_onsite': 'On-site Installation',
  'ems_form_submit': 'Request Quote',
  'ems_form_success': 'Thank you! We will contact you soon.',
  'ems_form_error': 'An error occurred while submitting the form. Please try again.',
  
  // EMS Calculator Results
  'ems_result_title': 'Indicative Quote',
  'ems_result_price_label': 'Estimated Price:',
  'ems_result_description': 'This is a preliminary calculation based on the provided data. For an accurate quote, please contact us.',
  'ems_result_email_label': 'Email address for future contact',
  'ems_result_email_required': 'Please enter your email address to download the PDF',
  'ems_result_pdf_button': 'Download Quote as PDF',
  'ems_result_new_calculation': 'New Calculation',
};

export default enTranslations;
